<script setup lang="ts">
import { useClipboard, useTimeoutFn } from '@vueuse/core'

interface Props {
  title: string | null
  openShare: boolean
  popupOnly?: boolean
  itemType: string
  urlPath: string
}

const props = withDefaults(defineProps<Props>(), {
  title: 'title here',
  openShare: false,
  popupOnly: false,
})

const emit = defineEmits(['closeShare'])
const el = ref<HTMLElement | null>(null)
const body = process.client && document.getElementsByTagName('body')[0]
const header = process.client && document.querySelector('header').parentElement
el.value = body
const isToggleExpanded = ref(false)
const isLocked = useScrollLock(el)
const { copy } = useClipboard()
const copiedUrl = `${encodeURI(`${useSetSubdomain(useGetSubdomain())}${props.urlPath}`)}?utm_source=copy_link&utm_medium=referral&utm_campaign=social_sharing`
const { isPending, start } = useTimeoutFn(() => {}, 3000, { immediate: false })

watch(() => props.openShare, (value) => {
  isToggleExpanded.value = value
  isLocked.value = !isLocked.value
  if (value)
    header.classList.remove('z-30')
})

function onShareLinkedin() {
  window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURI(`${window.location.origin}${props.urlPath}`)}${encodeURIComponent('?utm_source=linkedin&utm_medium=referral&utm_campaign=social_sharing')}`, '_blank')
}

function onShareTwitter() {
  window.open(`https://twitter.com/share?url=${encodeURI(`${window.location.origin}${props.urlPath}`)}${encodeURIComponent('?utm_source=twitter&utm_medium=referral&utm_campaign=social_sharing')}&text=${props.title || props.title}`, '_blank')
}

function onShareWA() {
  window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(props.title || props.title)} ${encodeURI(`${window.location.origin}${props.urlPath}`)}${encodeURIComponent('?utm_source=whatsapp&utm_medium=referral&utm_campaign=social_sharing')}`, '_blank')
}

function onShareTelegram() {
  window.open(`https://t.me/share/url?url=${encodeURI(`${window.location.origin}${props.urlPath}`)}${encodeURIComponent('?utm_source=telegram&utm_medium=referral&utm_campaign=social_sharing')}`, '_blank')
}

function toogleExpanded() {
  isToggleExpanded.value = !isToggleExpanded.value
  emit('closeShare')
  header.classList.toggle('z-30')
}
</script>

<template>
  <div v-if="props.openShare">
    <div v-if="isToggleExpanded" class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity z-40" @click="toogleExpanded()" />
    <div :class="`${(props.popupOnly && !isToggleExpanded) ? 'hidden' : (isToggleExpanded ? 'block fixed bottom-0' : 'hidden md:block bg-gray-50')} text-gray-900 text-center px-10 py-6 md:py-6 md:pb-8 md:px-6 bg-white z-50 w-full left-0`">
      <p class="text-sm md:text-base font-bold mb-10 md:mb-6">
        Share this {{ props.itemType }}
      </p>
      <div :class="`${props.popupOnly ? 'md:mb-6' : 'md:mb-0'} flex items-center space-x-5 mb-10 mx-auto w-fit`">
        <div class="flex-none">
          <div class="text-white rounded-full w-10 h-10 flex cursor-pointer" style="background-color: #0076B2;" @click="onShareLinkedin()">
            <Icon name="akar-icons:linkedin-fill" class="w-5 h-5 m-auto" />
          </div>
        </div>
        <div class="flex-none">
          <div class="text-white rounded-full w-10 h-10 flex cursor-pointer" style="background-color: #181818;" @click="onShareTwitter()">
            <Icon name="ri:twitter-x-fill" class="w-5 h-5 m-auto" />
          </div>
        </div>
        <div class="flex-none">
          <div class="text-white rounded-full w-10 h-10 flex cursor-pointer" style="background-color: #60D669;" @click="onShareWA()">
            <Icon name="akar-icons:whatsapp-fill" class="w-5 h-5 m-auto" />
          </div>
        </div>
        <div class="flex-none">
          <div class="text-white rounded-full w-10 h-10 flex cursor-pointer" style="background-color: #2AABEE;" @click="onShareTelegram()">
            <Icon name="teenyicons:telegram-outline" class="w-5 h-5 m-auto" />
          </div>
        </div>
        <div class="flex-none relative">
          <span v-if="isPending" class="text-xs border border-indigo-500 rounded-sm bg-indigo-50 p-2 absolute w-[80px] right-0 -top-12">Link Copied</span>
          <div class="text-white rounded-full w-10 h-10 flex cursor-pointer" style="background-color: #5843E5;" @click="(copy(copiedUrl), start())">
            <Icon :name="!isPending ? 'ic:baseline-content-copy' : 'mdi:check'" class="w-5 h-5 m-auto" />
          </div>
        </div>
      </div>
      <BaseAtomsButton v-if="isToggleExpanded" size="sm" class="!text-xs font-bold text-primary-600 bg-gray-50 hover:bg-transparent min-w-[240px]" @click="toogleExpanded()">
        Cancel
      </BaseAtomsButton>
    </div>
  </div>
</template>

<style scoped>
.w-fit {
  width: fit-content;
}
body{
  overflow: scroll;
}
</style>
